"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDiscountCodeInfo = void 0;
const zod_1 = require("zod");
exports.ZDiscountCodeInfo = zod_1.z.object({
    code: zod_1.z.string().optional(),
    link: zod_1.z.string(),
});
//# sourceMappingURL=models.js.map